export var phases = [
    {
        name: 'setup',
        stepCount: 6,
    },
    {
        name: 'test',
        stepCount: 23,
    },
    {
        name: 'result',
        stepCount: 3,
    },
];
